<template lang="">
  <div class="bbs_write">
    <!-- <div class="bbs_info">
      <div class="required">* 필수 입력사항</div>
    </div> -->
    <table class="bbs_tbl">
      <colgroup>
        <col style="width:140px">
        <col style="width:auto">
      </colgroup>
      <tbody>
        <tr>
          <th scope="row"><span class="txt_required">* 회원 PRID</span></th>
          <td>
            <div class="item">
              <input type="text" class="i_txt lineless" placeholder="아이디를 입력or검색해주세요" style="width:295px" required v-model="username">
              <div class="scroll_wrap">
              <button type="button" class="c_btn" style="width:15px;height:15px;">close</button>
              </div>
              <button type="button" class="bt_base primary id_btn" style="width:129px;" @click="checkDuplicate">중복아이디 검색</button>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row"><span class="txt_required">* 비밀번호</span></th>
          <td>
            <div class="item">
              <input type="password" class="i_txt type_full lineless" placeholder="비밀번호를 입력해 주세요" required v-model="pwd">
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row"><span class="txt_required">* 비밀번호 확인</span></th>
          <td>
            <div class="item">
              <input type="password" class="i_txt type_full lineless" placeholder="비밀번호를 확인해 주세요" required v-model="pwdCheck">
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row"><span class="txt_required">* 회원이름</span></th>
          <td>
            <div class="item">
              <input type="text" class="i_txt type_full lineless" placeholder="회원의 이름을 입력해 주세요" required v-model="name">
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">직위</th>
          <td>
            <div class="item">
              <input type="text" class="i_txt type_full lineless" placeholder="직위를 입력해 주세요" required v-model="division">
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row"><span class="txt_required">* 이메일</span></th>
          <td>
            <div class="item">
              <input type="email" class="i_txt type_full lineless" placeholder="이메일을 입력해 주세요" required v-model="email">
            </div>
          </td>
        </tr>
        
      </tbody>
    </table>
  </div>

  <div class="bbs_controller">
    <div class="rgt_area">
      <button type="button" class="bt_base primary large_h" @click="createAccount">저장</button>
      <button type="button" class="bt_base gray large_h" @click="toList">목록</button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

const adminAccountModule = 'adminAccountModule'

export default {
  data () {
    return {
      username: '',
      pwd: '',
      pwdCheck: '',
      name: '',
      division: '',
      email: '',
      usernameCheck: false,
      roleType: 'NORMAL'
    }
  },

  methods: {
    ...mapActions(adminAccountModule, [
      'requestCheckDuplicate',
      'requestCreateAccount'
    ]),

    toList () {
      this.$router.push({ name: "AccountManageListPage" })
    },

    async checkDuplicate() {
      if (await this.requestCheckDuplicate(this.username)) {
        alert('중복된 아이디입니다.')
      } else {
        alert('사용 가능한 아이디입니다.')
        this.usernameCheck = true
      }
    },

    async createAccount() {
      if (this.pwd !== this.pwdCheck) alert("비밀번호가 일치하지 않습니다")
      if (!this.usernameCheck) alert("아이디 중복확인을 해주세요")
      else {
        const {username, description, pwd, name, division, email, roleType} = this
        if (await this.requestCreateAccount({username, description, pwd, name, division, email, roleType})) {
          alert("계정이 생성 됐습니다")
          this.$router.push({name: 'AccountManageListPage'})
        }
      }
    }
  }
}
</script>
<style lang="">
    
</style>